import { toast } from 'react-toastify';
import type { ReactNode } from 'react';
import GreenCheckIcon from '@/assets/icons/GreenCheckIcon.svg?react';
import ColoredWarningIcon from '@/assets/icons/ColoredWarning.svg?react';
import PartyIcon from '@/assets/icons/PartyIcon.svg?react';

type ToastType = 'default' | 'success' | 'warning' | 'congratulations';

export const useToast = () => {
  const showToast = (type: ToastType, text: string | ReactNode) => {
    // 같은 타입 토스트가 이미 떠있으면 중복 생성 방지 (깜빡임 방지)
    // 다른 타입이 들어오면 기존 토스트를 닫고 새로 띄움
    if (toast.isActive(type)) return;
    toast.dismiss();

    switch (type) {
      case 'success':
        toast(
          <div className="flex items-center gap-2 whitespace-nowrap">
            <GreenCheckIcon />
            <span>{text}</span>
          </div>,
          { toastId: type },
        );
        return;
      case 'warning':
        toast(
          <div className="flex items-center gap-2">
            <ColoredWarningIcon />
            <span>{text}</span>
          </div>,
          { toastId: type },
        );
        return;
      case 'congratulations':
        toast(
          <div className="flex items-center gap-2">
            <PartyIcon />
            <span>{text}</span>
          </div>,
          { toastId: type },
        );
        return;
      default:
        toast(text, { toastId: type });
        return;
    }
  };

  return { showToast };
};
